import React, { useEffect, useState, useRef } from 'react';
import Header from '../../components/common/Header';
import Button from '../../components/ui/Button2';
import CategoryGrid from './CategoryGrid';
import { useDispatch } from 'react-redux';
import {
  getAdvertismentService,
  getCategoriesService,
  getMyCartService,
  getStoreInfoService,
} from 'redux/services/general_service';
import FeaturedProducts from './FeaturedProducts';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import Footer from '../../components/common/Footer';
import HeroSection from './HeroSection';
import FlashSales from './FlashSales';
import TrendingProducts from './TrendingProducts';
import MusicExperience from './MusicExperience';
import GadgetDeals from './GadgetDeals';
import HomeAppliances from './HomeAppliances';
import FashionDeals from './FashionDeals';
import NewArrivals from './NewArrivals';
import DiscountedProducts from './DiscountedProducts';
const Home = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const isRTL = i18n.language === 'ar';

  const pets = [
    {
      id: 1,
      name: 'MO231 - Pomeranian White',
      gene: 'Male',
      age: '02 months',
      price: '6.900.000 VND',
      image: 'assets/images/pet1.png',
    },
    {
      id: 2,
      name: 'MO502 - Poodle Tiny Yellow',
      gene: 'Female',
      age: '02 months',
      price: '3.900.000 VND',
      image: 'assets/images/pet2.png',
    },
    {
      id: 3,
      name: 'MO102 - Poodle Tiny Sepia',
      gene: 'Male',
      age: '02 months',
      price: '4.000.000 VND',
      image: 'assets/images/pet3.png',
    },
    {
      id: 4,
      name: 'MO512 - Alaskan Malamute Grey',
      gene: 'Male',
      age: '02 months',
      price: '8.900.000 VND',
      image: 'assets/images/pet4.png',
    },
    {
      id: 5,
      name: 'MO231 - Pembroke Corgi Cream',
      gene: 'Male',
      age: '02 months',
      price: '7.900.000 VND',
      image: 'assets/images/pet5.png',
    },
    {
      id: 6,
      name: 'MO502 - Pembroke Corgi Tricolor',
      gene: 'Female',
      age: '02 months',
      price: '9.000.000 VND',
      image: 'assets/images/pet6.png',
    },
    {
      id: 7,
      name: 'MO231 - Pomeranian White',
      gene: 'Female',
      age: '02 months',
      price: '6.500.000 VND',
      image: 'assets/images/pet7.png',
    },
    {
      id: 8,
      name: 'MO512 - Poodle Tiny Dairy Cow',
      gene: 'Male',
      age: '02 months',
      price: '5.000.000 VND',
      image: 'assets/images/pet8.png',
    },
  ];

  const articles = [
    {
      id: 1,
      title: 'What is a Pomeranian? How to Identify Pomeranian Dogs',
      description:
        'The Pomeranian, also known as the Pomeranian (Pom dog), is always in the top of the cutest pets. Not only that, the small, lovely, smart, friendly, and skillful circus dog breed.',
      image: 'assets/images/art1.png',
      category: 'Pet knowledge',
    },
    {
      id: 2,
      title: 'Dog Diet You Need To Know',
      description:
        "Dividing a dog's diet may seem simple at first, but there are some rules you should know so that your dog can easily absorb the nutrients in the diet. For those who are just starting to raise dogs, especially newborn puppies with relatively weak resistance.",
      image: 'assets/images/art2.png',
      category: 'Pet knowledge',
    },
    {
      id: 3,
      title: 'Why Dogs Bite and Destroy Furniture and How to Prevent It Effectively',
      description:
        'Dog bites are common during development. However, no one wants to see their furniture or important items being bitten by a dog.',
      image: 'assets/images/art3.png',
      category: 'Pet knowledge',
    },
  ];

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    dispatch(getCategoriesService({ page: 1 }));
    dispatch(getStoreInfoService());
    dispatch(getMyCartService());
    dispatch(getAdvertismentService({ page: 1 }));
  }, []);

  const heroRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef.current) return;
      const heroHeight = heroRef.current.offsetHeight;

      if (window.scrollY >= heroHeight) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>Star E-commerce Platform | Shop Electronics, Fashion & Home Appliances Online</title>
        <meta
          name="description"
          content="Discover amazing deals on electronics, fashion accessories, home appliances & lifestyle products at Star. Enjoy flash sales, trending collections, new arrivals & exclusive Black Friday offers with secure shopping experience."
        />
        <meta
          property="og:title"
          content="Star E-commerce Platform | Shop Electronics, Fashion & Home Appliances Online"
        />
        <meta
          property="og:description"
          content="Discover amazing deals on electronics, fashion accessories, home appliances & lifestyle products at Star. Enjoy flash sales, trending collections, new arrivals & exclusive Black Friday offers with secure shopping experience."
        />
      </Helmet>

      <div className="min-h-screen bg-white">
        <Header />

        <main>
          <HeroSection />

          <DiscountedProducts />

          <TrendingProducts />
          <MusicExperience />

          <FeaturedProducts />

          <NewArrivals />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Home;
